// Note: we have a dependency on the toast module to display error and success messages, but the dependency is not circular.
// Additional depencies can be added at runtime by adding to the errorHandler or responseHandler delegates.
// For instance, the http module uses the dialog module to display alerts (via response handlers), and the dialog module uses the http module to load dialogs.
import { get, getFrom, post, postTo, withUrlParams, convertUrlParams, removeUrlParams, getPageParams, withPageParams, resolveUrl, asText, decodeJson, getOrigin, getNonce, debounce, deleteRequest } from "./fetch-helpers";
import { withSpinner } from "./with-spinner";
import { ToastErrorHandler, ToastFallback } from "./toast-error-handler";
import { withButtonDisabled } from "./with-button-disabled";
import { JsonErrorHandler } from "./json-error-handler";
import { withErrorHandler } from "./with-error-handler";
import { BannerUpdateHandler, JsonResponseHandler, PageRedirectHandler, PageReloadHandler, ToastSuccessHandler, ViewUpdateHandler } from "./json-response-handler";
import { sendSynchronousPostRequest, sendSynchronousRequest } from "./synchronous-request";

const errorHandler = new JsonErrorHandler;
errorHandler.delegates.push(new ToastErrorHandler);
const withToastOnError = (request: Promise<Response>, fallbackMessage?: string) => {
    return withErrorHandler(request, errorHandler.withFallback(new ToastFallback(fallbackMessage)));
}

const responseHandler = new JsonResponseHandler;
responseHandler.delegates.push(new PageReloadHandler, new PageRedirectHandler, new BannerUpdateHandler, new ToastSuccessHandler, new ViewUpdateHandler)
const withResponseHandler = (request: Promise<Response>) => {
    return request.then(response => responseHandler.onResponse(response));
}

export default {
    get,
    getFrom, 
    post,
    postTo,
    delete: deleteRequest,
    resolveUrl,
    withUrlParams,
    convertUrlParams,
    removeUrlParams,
    getPageParams,
    withPageParams,
    withSpinner,
    withToastOnError,
    withButtonDisabled,
    withResponseHandler,
    asText,
    decodeJson,
    getOrigin, 
    getNonce,
    debounce,
    sendSynchronousPostRequest,
    sendSynchronousRequest,
    errorHandler,
    responseHandler,
}
